import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function generateGetHeaders(config) {
  return function (customHeaders) {
    return _objectSpread(_objectSpread({}, customHeaders !== null && customHeaders !== void 0 ? customHeaders : {}), config.headers);
  };
}

function generateGetGQLClientParams(_ref) {
  var getHeaders = _ref.getHeaders,
      getApiUrl = _ref.getApiUrl;
  return function (operation, options) {
    var props = [operation];

    if (options && Object.keys(options).length > 0) {
      var variables = options.variables,
          propApiVersion = options.apiVersion,
          headers = options.headers,
          retries = options.retries;
      props.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, variables ? {
        variables: variables
      } : {}), headers ? {
        headers: getHeaders(headers)
      } : {}), propApiVersion ? {
        url: getApiUrl(propApiVersion)
      } : {}), retries ? {
        retries: retries
      } : {}));
    }

    return props;
  };
}

export { generateGetGQLClientParams, generateGetHeaders };